import React, { useCallback } from 'react'
import { Typography, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useParams, navigate } from '@reach/router'

import IconButton from '_components/svg/icon-button'
import Profile from '_assets/icons/ic-profile.svg'
import Trash from '_assets/icons/ic-trash.svg'
import { USER_ROLES, USER_FIELDS, USER_FIELDS_LABEL } from '_utils/user'
import { formatPhoneValueMask, parseToNumber } from '_utils/helpers'

import useStyles from './styles'

const isUserInactive = user => {
  if (user == null) return false
  const raw = user.toJS ? user.toJS() : user
  const isActive = raw.isActive ?? raw.is_active
  if (isActive === false || isActive === 'false') return true
  return false
}

const UserInfo = ({ user, index, handleDeleteUser, isProvider }) => {
  const styles = useStyles()
  const { agencyId, providerId } = useParams()
  const inactive = isUserInactive(user)
  const role = user.get ? user.get('role') : user.role
  const roleLabel = USER_ROLES.CS_MANAGER === role ? 'CS Gestor' : 'CS Aprovador'
  const profileTooltipInactive = (
    <>
      Usuário desativado
      <br />
      {roleLabel}
    </>
  )

  const handleUser = useCallback(() => {
    if (isProvider) {
      const path = user?.id
        ? `/prestador/${providerId}/usuario/${user?.id}`
        : `/prestador/${providerId}/criar-usuario`
      navigate(path, {
        state: {
          providerUser: {
            name: user?.name || user?.person_responsible_name || user?.personResponsibleName || '',
            email: user?.email || '',
            phone: user?.phone || user?.telefone || '',
            isActive: user?.isActive ?? user?.is_active ?? true,
            isAdmin: user?.isAdmin ?? user?.is_admin ?? false,
          },
        },
      })
      return
    }
    navigate(`/imobiliaria/${agencyId}/usuario/${user?.id}`)
  }, [isProvider, providerId, agencyId, user])

  const handleDelete = useCallback(() => {
    handleDeleteUser(user)
  }, [handleDeleteUser, user])

  return (
    <Grid className={styles.wrapper}>
      <button className={styles.details} type="button" onClick={handleUser}>
        {[USER_FIELDS.NAME, USER_FIELDS.EMAIL, USER_FIELDS.PHONE].map(name => (
          <Grid key={`user-${index}-${name}`}>
            <Typography
              className={classnames(styles.title, inactive && styles.textMuted)}
              component="p"
              variant="body2"
              color="inherit"
            >
              {USER_FIELDS_LABEL[name]}
            </Typography>
            <Typography
              className={classnames(styles.value, inactive && styles.textMuted)}
              component="p"
              variant="body1"
              color="inherit"
            >
              {name === USER_FIELDS.PHONE
                ? (() => {
                    const digits = parseToNumber(user?.[name])
                    const localDigits =
                      digits?.startsWith('55') && digits?.length >= 12 ? digits.slice(2) : digits
                    return formatPhoneValueMask(localDigits)
                  })()
                : name === USER_FIELDS.NAME
                ? user?.name || user?.person_responsible_name || user?.personResponsibleName || ''
                : user?.[name]}
            </Typography>
          </Grid>
        ))}
      </button>
      {!isProvider && (
        <Grid container className={styles.actions}>
          <IconButton
            icon={Profile}
            color={USER_ROLES.CS_MANAGER === role ? 'primary' : 'inherit'}
            tooltip={inactive ? profileTooltipInactive : roleLabel}
          />
          <IconButton icon={Trash} onClick={handleDelete} />
        </Grid>
      )}
    </Grid>
  )
}

UserInfo.propTypes = {
  user: PropTypes.shape({ role: PropTypes.string }).isRequired,
  index: PropTypes.number.isRequired,
  handleDeleteUser: PropTypes.func.isRequired,
  isProvider: PropTypes.bool,
}

UserInfo.defaultProps = {
  isProvider: false,
}

export default React.memo(UserInfo)
